import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class MentorBindingRejectedNotification extends Notification {
  icon() {
    return 'fas fa-times-circle';
  }

  href() {
    const user = app.session.user;
    return user ? app.route('user.taroMentors', { username: user.slug() }) : '#';
  }

  content() {
    const fromUser = this.attrs.notification.fromUser();
    const name = fromUser ? fromUser.displayName() : '导师';
    return name + ' 拒绝了你的拜师申请';
  }

  excerpt() {
    const data = this.attrs.notification.content() || {};
    return data.reason || null;
  }
}
